import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";



export var UpdateDepartmentRes;
export const UpdateDepartmentTodo = createAsyncThunk('admi UpdateDepartment', async (data) => {
    console.log(data)
    try {
        const res = await axios({
            method: "put",
            url: process.env.REACT_APP_API_URL +  `superadmin/department/${data?.id}`,
            data: {
                "name": data?.department,
                "status": data?.status,
                "modified_by": localStorage.getItem('user_id'),
            },
            headers: { "Content-Type": "application/json", "Authorization": 'Bearer ' + localStorage.getItem('user_token') }
        })
        return UpdateDepartmentRes = res.data

    } catch (error) {
        return UpdateDepartmentRes = error.response.data
    }
})